import { Toast } from 'vant';

export default {
  install(Vue) {
    Vue.prototype.$showToast = (message, options = {}) => {
      // 根据类型添加自定义类名
      const typeClass = options.type ? `custom-toast-${options.type}` : '';
      const className = options.className 
        ? `${options.className} ${typeClass}` 
        : typeClass;

      Toast({
        message,
        duration: options.duration || 2000,  // 建议至少2000ms
        ...options,
        className,  // 注入合并后的类名
      });
    };
  },
};